import { render, staticRenderFns } from "./TerminalManage.vue?vue&type=template&id=5a701388&scoped=true"
import script from "./TerminalManage.vue?vue&type=script&lang=js"
export * from "./TerminalManage.vue?vue&type=script&lang=js"
import style0 from "./TerminalManage.vue?vue&type=style&index=0&id=5a701388&prod&lang=scss&scoped=true"
import style1 from "./TerminalManage.vue?vue&type=style&index=1&id=5a701388&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a701388",
  null
  
)

export default component.exports